import {css} from '@emotion/react'

export const cssCustomFieldComponentBorder = css`
	border: 1px rgb(204, 204, 204) solid;
	border-radius: 4px;
`